<template>
	<div> 
		<loader />
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';

	export default{
		mounted(){
			let params = [
				{
					key: 'table_number',
	    		value: this.$route.params.table_number	
				},
			]
			this.setRestaurantAuth(params)
			let self = this
			setTimeout(()=>{
				self.goToHome()
			},1000)
		},
		methods:{
      ...mapGetters(['getMerchant','getRestaurantAuth']),
      ...mapMutations(['setRestaurantAuth']),
			goToHome(){
	      this.$router.push({
	        path: "/" + this.getMerchant().code,
	      });
	    }
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/restaurant/applyTableNumber.vue